import {Sprite} from 'pixi.js';
import {KeypadView, KeypadViewMobileLandscape} from '@gongxigames/framework/slot/modules/keypad';
import {WinMeterView} from '@gongxigames/framework/slot/modules/winmeter/index';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {DeviceType} from '@gongxigames/framework/core';

export class WinMeterViewMobileLandscape extends WinMeterView {
    public static readonly NAME: symbol = Symbol('WinMeterViewMobileLandscape');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobileLandscape.NAME).mainSprite;
    }

    public getViewDependencies(): (symbol|string)[] {
        return [KeypadViewMobileLandscape.NAME];
    }
}
